/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetMentorshipRequestQueryVariables = Types.Exact<{
  slug: Types.Scalars["String"];
  claimId: Types.Scalars["Int"];
}>;

export type GetMentorshipRequestQuery = {
  claims: Array<{ stage: Pick<Types.Stage, "slug"> }>;
};

export const GetMentorshipRequestDocument = gql`
  query GetMentorshipRequest($slug: String!, $claimId: Int!) {
    claims(
      where: {
        pipeline: { is: { slug: { equals: $slug } } }
        id: { equals: $claimId }
      }
    ) {
      stage {
        slug
      }
    }
  }
`;

/**
 * __useGetMentorshipRequestQuery__
 *
 * To run a query within a React component, call `useGetMentorshipRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorshipRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorshipRequestQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      claimId: // value for 'claimId'
 *   },
 * });
 */
export function useGetMentorshipRequestQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetMentorshipRequestQuery,
    GetMentorshipRequestQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetMentorshipRequestQuery,
    GetMentorshipRequestQueryVariables
  >(GetMentorshipRequestDocument, baseOptions);
}
export function useGetMentorshipRequestLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetMentorshipRequestQuery,
    GetMentorshipRequestQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetMentorshipRequestQuery,
    GetMentorshipRequestQueryVariables
  >(GetMentorshipRequestDocument, baseOptions);
}
export type GetMentorshipRequestQueryHookResult = ReturnType<
  typeof useGetMentorshipRequestQuery
>;
export type GetMentorshipRequestLazyQueryHookResult = ReturnType<
  typeof useGetMentorshipRequestLazyQuery
>;
export type GetMentorshipRequestQueryResult = ApolloReactCommon.QueryResult<
  GetMentorshipRequestQuery,
  GetMentorshipRequestQueryVariables
>;
